import { render, staticRenderFns } from "./activity2.vue?vue&type=template&id=33f49a91&scoped=true"
import script from "./activity2.vue?vue&type=script&lang=js"
export * from "./activity2.vue?vue&type=script&lang=js"
import style0 from "./activity2.vue?vue&type=style&index=0&id=33f49a91&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f49a91",
  null
  
)

export default component.exports